import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';

import {Icon} from '@stubhub/bamboo';
import PriceDisplay from '@stubhub/react-price-display';

import messages from './messages';

const PriceFeeText = ({preSelectIncludeFees, hideEstimatedFee}) => {
  let legalProps = {};

  if (preSelectIncludeFees) {
    if (hideEstimatedFee) {
      legalProps = messages.LEGAL_INFO_INCLUDE_INCLUDE_FEES;
    } else {
      legalProps = messages.LEGAL_INFO_INCLUDE_ESTIMATED_FEES;
    }
  } else if (hideEstimatedFee) {
    legalProps = messages.LEGAL_INFO_EXCLUDE_FEES;
  } else {
    legalProps = messages.LEGAL_INFO_EXCLUDE_ESTIMATED_FEES;
  }

  return <FormattedMessage {...legalProps} />;
};

PriceFeeText.propTypes = {
  preSelectIncludeFees: PropTypes.bool,
  hideEstimatedFee: PropTypes.bool,
};

const faceValueMessage = (faceValue) => {
  if (!faceValue || faceValue.length === 0) {
    return <FormattedMessage {...messages.LEGAL_INFO_NO_FACE_VALUE} />;
  }
  if (faceValue.length === 1) {
    return (
      <FormattedMessage
        {...messages.LEGAL_INFO_FACE_VALUE}
        values={{
          amount: <PriceDisplay price={faceValue[0].amount} currency={faceValue[0].currency} decimalPlaces={2} />,
        }}
      />
    );
  }

  return (
    <>
      <FormattedMessage {...messages.LEGAL_INFO_SEVERAL_FACE_VALUE} />{' '}
      {faceValue.map((fV, index) => (
        <>
          <PriceDisplay price={fV.amount} currency={fV.currency} decimalPlaces={2} /> x {fV.quantity}
          {index + 1 < faceValue.length ? <> {', '} </> : <> </>}
        </>
      ))}
    </>
  );
};

export default (
  showLegal,
  isMobile,
  showFaceValue,
  faceValue,
  preSelectIncludeFees,
  hideEstimatedFee,
  showPriceIncludeVAT,
  showNonOfficial
) => {
  const legalInfo = (
    <>
      {showLegal ? (
        <div>
          <FormattedMessage {...messages.LEGAL_INFO_SET_BY_SELLER} />{' '}
          {!isMobile && (
            <PriceFeeText preSelectIncludeFees={preSelectIncludeFees} hideEstimatedFee={hideEstimatedFee} />
          )}{' '}
          {!isMobile && showPriceIncludeVAT && <FormattedMessage {...messages.LEGAL_INFO_INCLUDE_VAT} />}{' '}
          <FormattedMessage {...messages.LEGAL_INFO_VARY_FACE_VALUE} />
        </div>
      ) : null}
      {showNonOfficial && (
        <div>
          <FormattedMessage {...messages.LEGAL_INFO_NON_OFFICIAL_SELLER} />
        </div>
      )}
      {showFaceValue ? <div>{faceValueMessage(faceValue)}</div> : null}
    </>
  );

  return [
    {
      key: 'legalInfo',
      type: 'legal',
      title: <FormattedMessage {...messages.LEGAL_INFO_TITLE} />,
      info: legalInfo,
      icon: <Icon name="Price" />,
    },
  ];
};
